export const QA_NAME_CALENDAR_RAIL_CURRENT_USER = 'calendarRailCurrentUser'

export const QA_NAME_CALENDAR_RAIL_CURRENT_USER_NAME =
  'calendarRailCurrentUserName'
